import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import React, { useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { ExportsComponent } from './ExportsComponent';
import { isNumber } from './helpers';

const closeIcon = '/-/media/Project/FAB2/shared/images/icon_close-blue.svg';

// Refer to the excel sheet that was shared by the client to check the calculations logic
const ScheduleModal = ({
  t,
  showModal,
  setShowModal,
  payBackValue,
  borrow,
  monthlyRepayment,
  reducingRate,
  data,
  personal = false,
}) => {
  const rows = new Array(payBackValue).fill(true);

  const componentRef = useRef();

  let tableData = [];

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="filters__modal--backdrop"
      contentClassName="schedule__modal--content"
      dialogClassName="schedule__modal--dialog content"
      className="schedule__modal"
      centered
    >
      <img onClick={() => setShowModal(false)} className="close-icon" src={closeIcon} alt="close" />
      <div className="schedule__modal--header">
        <h4>
          <Text field={data?.amortisationScheduleLabel} />
        </h4>
        <div className="header-content">
          <RichText field={data?.amortisationScheduleText} className="header-content--desc" />
          <div className="header-content--actions">
            <ExportsComponent t={t} data={tableData} componentRef={componentRef} />
          </div>
        </div>
      </div>
      <div className="schedule__modal--body">
        <div className="table-responsive">
          <table ref={componentRef} className="table table-bordered modal-table">
            <thead>
              <tr>
                <th scole="col">
                  <Text field={data?.paymentNoLabel} />
                </th>
                <th scole="col">
                  <Text field={data?.openingBalanceLabel} />
                </th>
                <th scole="col">
                  <Text field={data?.installmentAmountLabel} />
                </th>
                <th scole="col">
                  <Text field={data?.interestLabel} />
                </th>
                <th scole="col">
                  <Text field={data?.principalLabel} />
                </th>
                <th scole="col">
                  <Text field={data?.closingBalanceLabel} />
                </th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                if (
                  !isNumber(payBackValue) ||
                  !isNumber(borrow) ||
                  !isNumber(monthlyRepayment) ||
                  !isNumber(reducingRate)
                ) {
                  return;
                }
                let previousClosingBalance = borrow;
                return rows.map((_, rowKey) => {
                  const numberOfDigits = payBackValue.toString()?.length;
                  const installmentNo = (rowKey + 1)?.toLocaleString('en-US', {
                    minimumIntegerDigits: numberOfDigits,
                    useGrouping: false,
                  });
                  const openingBalance = previousClosingBalance;
                  const installmentAmount = monthlyRepayment;
                  const interest = personal
                    ? (openingBalance * (reducingRate / 100)) / 12
                    : (openingBalance * reducingRate) / 12;
                  const principal = installmentAmount - interest;
                  let closingBalance = Math?.abs(openingBalance - principal);
                  previousClosingBalance = closingBalance;
                  tableData.push({
                    [data?.paymentNoLabel?.value]: installmentNo,
                    [data?.openingBalanceLabel?.value]: openingBalance,
                    [data?.installmentAmountLabel?.value]: installmentAmount,
                    [data?.interestLabel?.value]: interest,
                    [data?.principalLabel?.value]: principal,
                    [data?.closingBalanceLabel?.value]: closingBalance,
                  });
                  return (
                    <tr key={rowKey}>
                      <td scope="row">{installmentNo}</td>
                      <td>
                        {openingBalance.toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        {installmentAmount.toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        {interest.toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        {principal.toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        {closingBalance.toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  );
                });
              })()}
            </tbody>
          </table>
        </div>
      </div>
      <div className="schedule__modal--footer">
        <RichText className="footer-desc" field={data?.amortisationScheduleAdditionalText} />
        <ExportsComponent t={t} data={tableData} componentRef={componentRef} />
      </div>
    </Modal>
  );
};

export default withTranslation()(ScheduleModal);
